import cn from "classnames";

import i from "@styles/icons.module.scss";

import s from "./Notice.module.scss";

const Notice = ({ className, text, color = "main", children, html = null }) => {
  const classes = cn(s.notice, s[color], className);
  return (
    <div className={classes}>
      <icon className={cn(i.infoCircle, s.icon)} />
      {html ? (
        <div
          className={cn(s.message, s.html)}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (
        <div className={s.message}>{text || children}</div>
      )}
    </div>
  );
};
export default Notice;
